import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function VidletLogo(props: SvgIconProps) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height="127"
      width="174"
      viewBox="0 0 173.5 127"
      fontSize="large"
      {...props}
    >
      <linearGradient
        id="a"
        y2="41.8"
        gradientUnits="userSpaceOnUse"
        x2="112"
        y1="-14.7"
        x1="154"
      >
        <stop stopColor="#F37D21" offset="0" />
        <stop stopColor="#F37A23" offset=".06" />
        <stop stopColor="#EE6037" offset=".668" />
        <stop stopColor="#EC553D" offset="1" />
      </linearGradient>
      <path
        d="M174 0c-41 0-77 23.8-87 29.5l45.8 30 41-59.5z"
        className="right-wing"
        fill="url(#a)"
      />
      <linearGradient
        id="b"
        y2="98.7"
        gradientUnits="userSpaceOnUse"
        x2="75.7"
        y1="46"
        x1="109"
      >
        <stop stopColor="#C4202F" offset="0" />
        <stop stopColor="#BE2135" offset=".149" />
        <stop stopColor="#AE2246" offset=".436" />
        <stop stopColor="#95215A" offset=".829" />
        <stop stopColor="#8A2063" offset="1" />
      </linearGradient>
      <path className="right-wing" fill="url(#b)" d="M86.9 29.5V127L133 59.5" />
      <linearGradient
        id="c"
        y2="-11.5"
        gradientUnits="userSpaceOnUse"
        x2="23.1"
        y1="43.9"
        x1="63.6"
      >
        <stop stopColor="#DE4650" offset="0" />
        <stop stopColor="#DA4352" offset=".205" />
        <stop stopColor="#D13B59" offset=".499" />
        <stop stopColor="#C32C61" offset=".845" />
        <stop stopColor="#BC2365" offset="1" />
      </linearGradient>
      <path
        d="M87 29.5C75.2 22.2 39 0 0 0l41 59.5 46-30z"
        className="left-wing"
        fill="url(#c)"
      />
      <linearGradient
        id="d"
        y2="95.5"
        gradientUnits="userSpaceOnUse"
        x2="95.6"
        y1="49.8"
        x1="67.2"
      >
        <stop stopColor="#981F40" offset="0" />
        <stop stopColor="#902145" offset=".094" />
        <stop stopColor="#6D2958" offset=".527" />
        <stop stopColor="#552C65" offset=".84" />
        <stop stopColor="#4A2D69" offset="1" />
      </linearGradient>
      <path
        className="left-wing"
        fill="url(#d)"
        d="M86.9 29.5l-46.1 30L86.9 127"
      />
    </SvgIcon>
  );
}
